import React from "react";

export const WhatsAppIcon = ({ className }) => (
    <svg viewBox="0 0 22 22" fill="none" className={className}>
        <path
            d="M7.18 18.18C8.92 19.07 10.91 19.31 12.81 18.86C14.71 18.41 16.38 17.3 17.53 15.72C18.68 14.14 19.23 12.21 19.08 10.27C18.92 8.32 18.08 6.5 16.7 5.12C15.32 3.74 13.5 2.9 11.55 2.74C9.61 2.59 7.68 3.14 6.1 4.29C4.52 5.44 3.41 7.11 2.96 9.01C2.51 10.9 2.75 12.9 3.64 14.64L1.82 20L7.18 18.18Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const InstagramIcon = ({ className }) => (
    <svg viewBox="0 0 22 22" fill="none" className={className}>
        <path
            d="M15.46 1.82H6.37C3.86 1.82 1.82 3.85 1.82 6.36V15.46C1.82 17.97 3.86 20 6.37 20H15.46C17.97 20 20 17.97 20 15.46V6.36C20 3.85 17.97 1.82 15.46 1.82Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.54 10.34C14.66 11.09 14.53 11.87 14.17 12.54C13.82 13.22 13.27 13.77 12.58 14.12C11.9 14.46 11.12 14.58 10.37 14.46C9.61 14.34 8.92 13.98 8.38 13.44C7.83 12.9 7.48 12.2 7.36 11.45C7.24 10.69 7.35 9.92 7.7 9.23C8.04 8.55 8.59 7.99 9.27 7.64C9.95 7.29 10.72 7.16 11.48 7.27C12.25 7.39 12.97 7.75 13.52 8.3C14.07 8.85 14.43 9.56 14.54 10.34Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.91 5.91H15.92"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const TikTokIcon = ({ className }) => (
    <svg viewBox="0 0 22 22" fill="none" className={className}>
        <path
            d="M17.8 6.08C16.9 5.88 16.08 5.4 15.46 4.71C14.85 4.01 14.47 3.14 14.38 2.22V1.82H11.24V14.25C11.16 14.88 10.84 15.46 10.36 15.88C9.88 16.29 9.26 16.52 8.62 16.52C7.93 16.52 7.26 16.24 6.77 15.75C6.27 15.26 6 14.59 6 13.89C6 13.19 6.27 12.53 6.77 12.03C7.26 11.54 7.93 11.26 8.62 11.26C8.88 11.26 9.11 11.3 9.34 11.36V8.19C9.1 8.16 8.86 8.15 8.62 8.15C7.09 8.15 5.63 8.75 4.55 9.83C3.47 10.92 2.86 12.38 2.86 13.91C2.86 14.67 3.01 15.42 3.3 16.12C3.59 16.81 4.01 17.45 4.55 17.99C5.63 19.07 7.09 19.67 8.62 19.67C10.15 19.67 11.61 19.06 12.69 17.98C13.77 16.9 14.38 15.44 14.38 13.91V8.23C15.66 9.15 17.2 9.65 18.78 9.65V6.51C18.44 6.41 18.11 6.26 17.8 6.08Z"
            fill="currentColor"
        />
    </svg>
);

export const SnapchatIcon = ({ className }) => (
    <svg viewBox="0 0 22 22" fill="none" className={className}>
        <path
            d="M5.98 6.75C5.98 4.03 8.19 1.82 10.91 1.82C13.63 1.82 15.84 4.03 15.84 6.75C15.84 11.07 16.06 13.22 20 14.95C17.98 15.45 17.47 15.96 16.97 17.98C13.43 17.98 12.93 20 10.91 20C8.89 20 8.38 17.98 4.85 17.98C4.34 15.96 3.84 15.45 1.82 14.95C5.76 13.22 5.98 11.07 5.98 6.75Z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.82 14.55C5.29 12.65 5.29 10.86 2.69 8.18"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
        />
        <path
            d="M20 14.55C16.52 12.65 16.52 10.86 19.13 8.18"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
        />
    </svg>
);

export const YouTubeIcon = ({ className }) => (
    <svg viewBox="0 0 22 22" fill="none" className={className}>
        <path
            d="M2.27 6.36C1.64 9.36 1.64 12.46 2.27 15.45C2.35 15.76 2.52 16.04 2.74 16.26C2.96 16.48 3.24 16.64 3.54 16.73C8.42 17.54 13.4 17.54 18.27 16.73C18.58 16.64 18.85 16.48 19.08 16.26C19.3 16.04 19.46 15.76 19.54 15.45C20.18 12.46 20.18 9.36 19.54 6.36C19.46 6.06 19.3 5.78 19.08 5.56C18.85 5.34 18.58 5.17 18.27 5.09C13.4 4.28 8.42 4.28 3.54 5.09C3.24 5.17 2.96 5.34 2.74 5.56C2.52 5.78 2.35 6.06 2.27 6.36Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.09 13.64L13.64 10.91L9.09 8.18V13.64Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const XIcon = ({ className }) => (
    <svg viewBox="0 0 22 22" fill="none" className={className}>
        <path
            d="M16.58 2.05H19.59L13.02 9.55L20.75 19.77H14.7L9.96 13.58L4.53 19.77H1.52L8.55 11.74L1.14 2.05H7.34L11.63 7.71L16.58 2.05ZM15.53 17.97H17.19L6.44 3.75H4.65L15.53 17.97Z"
            fill="currentColor"
        />
    </svg>
);

export const FacebookIcon = ({ className }) => (
    <svg viewBox="0 0 22 22" fill="none" className={className}>
        <path
            d="M14.55 2.05H12.19C11.03 2.05 9.92 2.51 9.1 3.33C8.28 4.15 7.82 5.26 7.82 6.42V8.78H5.45V11.95H7.82V19.95H10.99V11.95H13.35L14.14 8.78H10.99V6.42C10.99 6.14 11.1 5.87 11.3 5.67C11.5 5.47 11.77 5.36 12.05 5.36H14.55V2.05Z"
            fill="currentColor"
        />
    </svg>
);

export const LinkedInIcon = ({ className }) => (
    <svg viewBox="0 0 22 22" fill="none" className={className}>
        <path
            d="M5.05 7.27H1.82V19.95H5.05V7.27Z"
            fill="currentColor"
        />
        <path
            d="M3.43 5.68C4.42 5.68 5.23 4.88 5.23 3.89C5.23 2.9 4.42 2.09 3.43 2.09C2.44 2.09 1.64 2.9 1.64 3.89C1.64 4.88 2.44 5.68 3.43 5.68Z"
            fill="currentColor"
        />
        <path
            d="M8.68 7.27H11.77V8.75C12.22 7.94 13.29 7.05 14.93 7.05C18.14 7.05 19.09 8.79 19.09 11.96V19.95H15.86V12.55C15.86 10.94 15.41 10.02 13.98 10.02C12.2 10.02 11.9 11.33 11.9 12.6V19.95H8.68V7.27Z"
            fill="currentColor"
        />
    </svg>
);

// The site's real social profiles — single source of truth so any
// component (Footer, author cards, share widgets) can reuse the same links.
export const SITE_SOCIAL_LINKS = [
    { label: "إكس", href: "https://x.com/wizfreelannce", Icon: XIcon },
    { label: "يوتيوب", href: "https://www.youtube.com/@wizfreelance", Icon: YouTubeIcon },
    { label: "سناب شات", href: "https://www.snapchat.com/@wizfreelance", Icon: SnapchatIcon },
    { label: "تيك توك", href: "https://www.tiktok.com/@wizfreelancee", Icon: TikTokIcon },
    { label: "إنستغرام", href: "https://www.instagram.com/wizfreelance.sa/", Icon: InstagramIcon },
    { label: "فيسبوك", href: "https://www.facebook.com/people/Wizfreelance/61563056669225/", Icon: FacebookIcon },
    { label: "لينكدإن", href: "https://www.linkedin.com/company/wizfreelance", Icon: LinkedInIcon },
];
